import { createAsyncThunk } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { postCreateAdditionalWork } from '../services/postCreateAdditionalWork.service';

const statusTimestampFieldMap = {
  PENDING: 'createdAt',
  ORDERED: 'orderedAt',
  CAN_BE_INVOICED: 'canBeInvoicedAt',
  INVOICED: 'invoicedAt',
  CANCELLED: 'cancelledAt',
};

export const createAdditionalWork = createAsyncThunk(
  'expenseTracking/createAdditionalWork',
  async (additionalWorkData, { getState }) => {
    const selectedProjectId = selectSelectedProjectId(getState());

    if (!selectedProjectId) {
      throw new Error('No project id given');
    }

    const status = additionalWorkData?.status || 'PENDING';
    const statusTimestampField = statusTimestampFieldMap[status];
    const now = dayjs().toISOString();

    const payload = {
      ...additionalWorkData,
      ...(statusTimestampField ? { [statusTimestampField]: now } : {}),
    };

    const createdAdditionalWork = await postCreateAdditionalWork(
      selectedProjectId,
      payload
    );

    return createdAdditionalWork;
  }
);
